import _ from 'lodash';


export class BaseFileUpload {

    constructor ($cookies, TokenService, Upload) {
        this.Upload = Upload;
        this.$cookies = $cookies;
        this.TokenService = TokenService;
    }

    get csrfToken() {
        return this.$cookies.get('csrftoken');
    }

    get token () {
        return this.TokenService.get();
    }

    uploadFile(url, data, contentType, method) {
        method = method || 'post';
        return this.Upload.upload({
            url: url,
            headers: {
                'Content-Type': contentType,
                'Authorization': `Token ${this.token}`,
                'X-CSRFToken': this.csrfToken,
            },
            data: data,
            method: method,
        });
    }
}


export class FileUpload extends BaseFileUpload {
    constructor ($cookies, TokenService, FileStore, Upload) {
        super($cookies, TokenService, Upload);

        this.FileStore = FileStore;
        this.index = 0;
    }

    uploadFiles (files) {
        for (let file of files) {
            this.uploadFile(file);
        }
    }

    uploadFile (file) {
        let data = _.extend({file: file}, this.FileStore.params);
        super.uploadFile(`${baseConfig.backendUrl}/api/v1/files`, data, file.type).then(
            _.bind(this.successHandler, this),
            _.bind(this.errorHandler, this),
            _.bind(this.progressHandler, this),
        )
    }

    successHandler(response) {
        let queueIndex = response.config.data.index;
        let indexInArray = Math.abs(this.index - queueIndex - 1);
        this.FileStore.list[indexInArray] = this.FileStore.restangularize(response.data)
    }

    errorHandler (response) { }

    progressHandler (event) {
        if (!event.config.data.$uploading) {
            this.FileStore.list.unshift({
                name: event.config.data.file.name,
                $uploading: true,
            });
            _.extend(event.config.data, {$uploading: true, index: this.index});
            this.index = this.index + 1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/files.upload.js